export default "__VITE_ASSET__DUQSfbwG__"